/**
 * Shopify Message Toast Component
 * Element Plus style toast notification component
 *
 * Basic usage:
 * MessageToast.success('Success message!');
 * MessageToast.error('Error message!');
 * MessageToast.warning('Warning message');
 * MessageToast.info('Info message');
 *
 * Advanced usage:
 * MessageToast.show({
 *   type: 'success',
 *   message: 'Custom message',
 *   duration: 5000,
 *   showClose: true
 * });
 */

(function(window) {
  'use strict';

  // Message queue for managing multiple messages
  let messageQueue = [];
  let containerInitialized = false;

  // Icon SVGs
  const icons = {
    success: `<svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"></path></svg>`,
    warning: `<svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"></path></svg>`,
    error: `<svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 0 1-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path></svg>`,
    info: `<svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path><path d="M512 336m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z"></path><path d="M536 448h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"></path></svg>`
  };

  // Close icon
  const closeIcon = `<svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor"><path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path></svg>`;

  // CSS styles
  const styles = `
    #message-toast-container {
      position: fixed;
      top: 20px;
      left: 0;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 9999;
      pointer-events: none;
    }

    .message-toast {
      min-width: 380px;
      max-width: 500px;
      padding: 15px 15px 15px 20px;
      margin-bottom: 10px;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      align-items: center;
      background-color: #fff;
      border: 1px solid #ebeef5;
      pointer-events: auto;
      transition: all 0.3s;
      transform: translateY(-20px);
      opacity: 0;
    }

    .message-toast.show {
      transform: translateY(0);
      opacity: 1;
    }

    .message-toast.hide {
      transform: translateY(-20px);
      opacity: 0;
    }

    .message-toast-icon {
      width: 16px;
      height: 16px;
      margin-right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .message-toast-content {
      flex: 1;
      font-size: 14px;
      line-height: 1.5;
      color: #606266;
    }

    .message-toast-close {
      color: #c0c4cc;
      cursor: pointer;
      margin-left: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      transition: color 0.3s;
      flex-shrink: 0;
    }

    .message-toast-close:hover {
      color: #909399;
    }

    /* Success */
    .message-toast-success {
      background-color: #f0fdf4;
      border-color: #86efac;
    }

    .message-toast-success .message-toast-icon {
      color: #166534;
    }

    /* Warning */
    .message-toast-warning {
      background-color: #fffbeb;
      border-color: #fcd34d;
    }

    .message-toast-warning .message-toast-icon {
      color: #92400e;
    }

    /* Error */
    .message-toast-error {
      background-color: #fef2f2;
      border-color: #fca5a5;
    }

    .message-toast-error .message-toast-icon {
      color: #991b1b;
    }

    /* Info */
    .message-toast-info {
      background-color: #f5f3ff;
      border-color: #c4b5fd;
    }

    .message-toast-info .message-toast-icon {
      color: #5b21b6;
    }

    /* Responsive design */
    @media (max-width: 480px) {
      .message-toast {
        min-width: 90%;
        max-width: 90%;
      }
    }
  `;

  // Initialize styles
  function initStyles() {
    if (document.getElementById('message-toast-styles')) return;

    const styleEl = document.createElement('style');
    styleEl.id = 'message-toast-styles';
    styleEl.textContent = styles;
    document.head.appendChild(styleEl);
  }

  // Initialize container
  function initContainer() {
    if (containerInitialized) return;

    let container = document.getElementById('message-toast-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'message-toast-container';
      document.body.appendChild(container);
    }

    containerInitialized = true;
  }

  // Close message function
  function closeMessage(messageId) {
    const messageEl = document.getElementById(messageId);
    if (!messageEl) return;

    // Hide animation
    messageEl.classList.remove('show');
    messageEl.classList.add('hide');

    // Remove from queue
    const index = messageQueue.indexOf(messageId);
    if (index > -1) {
      messageQueue.splice(index, 1);
    }

    // Remove element after animation completes
    setTimeout(() => {
      if (messageEl.parentNode) {
        messageEl.parentNode.removeChild(messageEl);
      }
    }, 300);
  }

  // Show message function
  function showMessage(options) {
    // Ensure styles and container are initialized
    initStyles();
    initContainer();

    // Default configuration
    const config = {
      type: 'info',
      message: '',
      duration: 3000,
      showClose: true,
      ...options
    };

    const container = document.getElementById('message-toast-container');
    const messageId = 'message-toast-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);

    // Create message element
    const messageEl = document.createElement('div');
    messageEl.id = messageId;
    messageEl.className = `message-toast message-toast-${config.type}`;

    // Set message content
    const closeBtn = config.showClose
      ? `<div class="message-toast-close" data-message-id="${messageId}">${closeIcon}</div>`
      : '';

    messageEl.innerHTML = `
      <div class="message-toast-icon">${icons[config.type] || icons.info}</div>
      <div class="message-toast-content">${config.message}</div>
      ${closeBtn}
    `;

    // Add to container
    container.appendChild(messageEl);

    // Add close button event
    if (config.showClose) {
      const closeButton = messageEl.querySelector('.message-toast-close');
      if (closeButton) {
        closeButton.addEventListener('click', function() {
          closeMessage(messageId);
        });
      }
    }

    // Add to message queue
    messageQueue.push(messageId);

    // Show animation
    setTimeout(() => {
      messageEl.classList.add('show');
    }, 10);

    // Auto close
    if (config.duration > 0) {
      setTimeout(() => {
        closeMessage(messageId);
      }, config.duration);
    }

    return messageId;
  }

  // Create MessageToast object
  const MessageToast = {
    /**
     * Show message
     * @param {Object|String} options - Configuration object or message text
     */
    show: function(options) {
      if (typeof options === 'string') {
        options = { message: options };
      }
      return showMessage(options);
    },

    /**
     * Success message
     * @param {String} message - Message content
     * @param {Number} duration - Display duration (milliseconds)
     */
    success: function(message, duration) {
      const options = {
        type: 'success',
        message: message
      };
      if (duration !== undefined) {
        options.duration = duration;
      }
      return showMessage(options);
    },

    /**
     * Warning message
     * @param {String} message - Message content
     * @param {Number} duration - Display duration (milliseconds)
     */
    warning: function(message, duration) {
      const options = {
        type: 'warning',
        message: message
      };
      if (duration !== undefined) {
        options.duration = duration;
      }
      return showMessage(options);
    },

    /**
     * Error message
     * @param {String} message - Message content
     * @param {Number} duration - Display duration (milliseconds)
     */
    error: function(message, duration) {
      const options = {
        type: 'error',
        message: message
      };
      if (duration !== undefined) {
        options.duration = duration;
      }
      return showMessage(options);
    },

    /**
     * Info message
     * @param {String} message - Message content
     * @param {Number} duration - Display duration (milliseconds)
     */
    info: function(message, duration) {
      const options = {
        type: 'info',
        message: message
      };
      if (duration !== undefined) {
        options.duration = duration;
      }
      return showMessage(options);
    },

    /**
     * Close specific message
     * @param {String} messageId - Message ID
     */
    close: function(messageId) {
      closeMessage(messageId);
    },

    /**
     * Close all messages
     */
    closeAll: function() {
      const queueCopy = [...messageQueue];
      queueCopy.forEach(id => closeMessage(id));
    }
  };

  // Export to global
  window.MessageToast = MessageToast;

})(window);
